import { useState } from "react";
import { AdminLogin } from "./AdminLogin";
import { AdminPostList } from "./AdminPostList";
import { AdminPostEditor } from "./AdminPostEditor";

type SubPage = "list" | "editor";

export function AdminPanel() {
  const [token, setToken] = useState<string | null>(
    () => localStorage.getItem("blog_token"),
  );
  const [subPage, setSubPage] = useState<SubPage>("list");
  const [editorPostId, setEditorPostId] = useState<number | null>(null);

  function handleLogin(t: string) {
    setToken(t);
    setSubPage("list");
  }

  function handleLogout() {
    localStorage.removeItem("blog_token");
    setToken(null);
  }

  function handleEdit(id: number) {
    setEditorPostId(id);
    setSubPage("editor");
  }

  function handleCreate() {
    setEditorPostId(null);
    setSubPage("editor");
  }

  function handleSaved() {
    setSubPage("list");
  }

  function handleCancel() {
    setSubPage("list");
  }

  if (!token) return <AdminLogin onLogin={handleLogin} />;

  if (subPage === "editor")
    return (
      <AdminPostEditor
        token={token}
        postId={editorPostId}
        onSaved={handleSaved}
        onCancel={handleCancel}
      />
    );

  return (
    <AdminPostList
      token={token}
      onEdit={handleEdit}
      onCreate={handleCreate}
      onLogout={handleLogout}
    />
  );
}
